import { createSlice } from '@reduxjs/toolkit'
import {
  fetchLimboGameReport,
  fetchPlinkoGameReport,
  fetchMineGameReport,
  fetchCoinHeistGameReport,
  fetchHiloGameReport,
  fetchDiceGameReport,
  fetchCoinFlipGameReport,
  fetchKenoGameReport,
  fetchRouletteGameReport
} from 'redux-thunk/thunk/GameReports/gameReports'

const initialState = {
  plinkoGameReport: null,
  limboGameReport: null,
  mineGameReport: null,
  coinHeistGameReport: null,
  hiloGameReport: null,
  diceGameReport: null,
  coinFlipGameReport: null,
  kenoGameReport: null,
  rouletteGameReport: null
}

const gameReportsSlice = createSlice({
  name: 'gameReportsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlinkoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          plinkoGameReport: action.payload
        }
      })
      .addCase(fetchLimboGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          limboGameReport: action.payload
        }
      })
      .addCase(fetchMineGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          mineGameReport: action.payload
        }
      })
      .addCase(fetchCoinHeistGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          coinHeistGameReport: action.payload
        }
      })
      .addCase(fetchHiloGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          hiloGameReport: action.payload
        }
      })
      .addCase(fetchDiceGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          diceGameReport: action.payload
        }
      })
      .addCase(fetchCoinFlipGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          coinFlipGameReport: action.payload
        }
      })
      .addCase(fetchKenoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          kenoGameReport: action.payload
        }
      })
      .addCase(fetchRouletteGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          rouletteGameReport: action.payload
        }
      })
  }
})

export default gameReportsSlice.reducer
